interface PackageCardSkeletonProps {
  count?: number
  isHomeScreenFlow?: boolean
}

const PackageCardSkeleton = ({
  count = 4,
  isHomeScreenFlow = true,
}: PackageCardSkeletonProps) => {
  const cardCount = Array(count).fill('')

  return (
    <div className="flex items-start gap-5 overflow-hidden">
      {cardCount.map((_, index) => (
        <div
          key={`skeleton-${index}`}
          role="status"
          aria-label="Loading..."
          className={`animate-pulse flex-shrink-0 ${
            isHomeScreenFlow
              ? 'min-w-[260px] max-w-[320px] w-full'
              : 'w-full'
          }`}
        >
          <div
            className={`w-full p-5 sm:p-6 bg-white rounded-lg border border-gray-300 flex flex-col justify-between gap-4 ${
              isHomeScreenFlow ? 'min-h-[280px]' : 'min-h-[200px]'
            }`}
          >
            <div className="space-y-3">
              {/* Title - 2 lines */}
              <div>
                <div className="h-5 bg-gray-200 rounded w-4/5 mb-1.5" />
                <div className="h-5 bg-gray-200 rounded w-3/5" />
              </div>
              {isHomeScreenFlow && (
                /* Report TAT */
                <div className="h-4 bg-gray-100 rounded w-2/5" />
              )}
              {/* Number of tests */}
              <div className="flex items-center gap-1.5">
                <div className="w-4 h-4 bg-gray-200 rounded" />
                <div className="h-4 bg-gray-100 rounded w-28" />
                <div className="w-4 h-4 bg-gray-100 rounded" />
              </div>
            </div>

            <div className="pt-1">
              {/* Price + discount */}
              <div className="flex items-baseline gap-2 mb-5">
                <div className="h-6 bg-gray-200 rounded w-16" />
                <div className="h-4 bg-gray-100 rounded w-12" />
                <div className="h-6 bg-gray-100 rounded w-16" />
              </div>
              {/* Book Now button */}
              <div className="h-10 w-28 bg-gray-200 rounded-md" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PackageCardSkeleton
